import ServiceDetailPage from "@/components/ServiceDetailPage";

const Operations = () => <ServiceDetailPage pageKey="operations" />;

export default Operations;
